export const SPECIAL_CLOSING_REASONS = {
  holiday: 'PlanningFormEvent.specialClosingReasons.holiday',
  weatherEvent: 'PlanningFormEvent.specialClosingReasons.weatherEvent',
  other: 'PlanningFormEvent.specialClosingReasons.other',
} as const;

export type SpecialClosingReason =
  typeof SPECIAL_CLOSING_REASONS[keyof typeof SPECIAL_CLOSING_REASONS];

export const OTHER_SPECIAL_CLOSING_REASON: SpecialClosingReason =
  SPECIAL_CLOSING_REASONS.other;

export const SPECIAL_CLOSING_REASON_OPTIONS: SpecialClosingReason[] =
  Object.values(SPECIAL_CLOSING_REASONS);

export function normalizeSpecialClosingReason(
  reason: unknown
): SpecialClosingReason {
  return SPECIAL_CLOSING_REASON_OPTIONS.includes(reason as SpecialClosingReason)
    ? (reason as SpecialClosingReason)
    : OTHER_SPECIAL_CLOSING_REASON;
}
